// extracted by mini-css-extract-plugin
module.exports = {"errorInTab":"TabErrorIcon_errorInTab__2R5JQ"};